/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { PaymentStatus } from './PaymentStatus';
import {
    PaymentStatusFromJSON,
    PaymentStatusFromJSONTyped,
    PaymentStatusToJSON,
    PaymentStatusToJSONTyped,
} from './PaymentStatus';

/**
 * 
 * @export
 * @interface OpenInvoiceOverview
 */
export interface OpenInvoiceOverview {
    /**
     * 
     * @type {string}
     * @memberof OpenInvoiceOverview
     */
    id: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof OpenInvoiceOverview
     */
    number: HeoTransactionNumber;
    /**
     * 
     * @type {Date}
     * @memberof OpenInvoiceOverview
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OpenInvoiceOverview
     */
    paymentDueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof OpenInvoiceOverview
     */
    total: number;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof OpenInvoiceOverview
     */
    paymentStatus: PaymentStatus;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof OpenInvoiceOverview
     */
    paymentMethod: PaymentMethod;
    /**
     * 
     * @type {PaymentType}
     * @memberof OpenInvoiceOverview
     */
    paymentType: PaymentType;
}



/**
 * Check if a given object implements the OpenInvoiceOverview interface.
 */
export function instanceOfOpenInvoiceOverview(value: object): value is OpenInvoiceOverview {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentType' in value) || value['paymentType'] === undefined) return false;
    return true;
}

export function OpenInvoiceOverviewFromJSON(json: any): OpenInvoiceOverview {
    return OpenInvoiceOverviewFromJSONTyped(json, false);
}

export function OpenInvoiceOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenInvoiceOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': HeoTransactionNumberFromJSON(json['number']),
        'createdAt': (new Date(json['createdAt'])),
        'paymentDueDate': json['paymentDueDate'] == null ? undefined : (new Date(json['paymentDueDate'])),
        'total': json['total'],
        'paymentStatus': PaymentStatusFromJSON(json['paymentStatus']),
        'paymentMethod': PaymentMethodFromJSON(json['paymentMethod']),
        'paymentType': PaymentTypeFromJSON(json['paymentType']),
    };
}

export function OpenInvoiceOverviewToJSON(json: any): OpenInvoiceOverview {
    return OpenInvoiceOverviewToJSONTyped(json, false);
}

export function OpenInvoiceOverviewToJSONTyped(value?: OpenInvoiceOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': HeoTransactionNumberToJSON(value['number']),
        'createdAt': value['createdAt'].toISOString(),
        'paymentDueDate': value['paymentDueDate'] == null ? value['paymentDueDate'] : value['paymentDueDate'].toISOString().substring(0,10),
        'total': value['total'],
        'paymentStatus': PaymentStatusToJSON(value['paymentStatus']),
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'paymentType': PaymentTypeToJSON(value['paymentType']),
    };
}

